<script lang="ts">
	import { type FinancialNumber } from 'shared/number'

	import HeaderPrice from './HeaderPrice.svelte'
	import CustomAddToCart from './CustomAddToCart.svelte'

	export let base_price: FinancialNumber
	export let promo_discount_rate: FinancialNumber
	export let configured_price: FinancialNumber
	export let product_title: string
	export let cart_endpoint: string
	export let shopping_cart_object: { [key: string]: any }
	export let disable_add_to_cart = false
	export let show_color_picker = false
	export let compact_color_picker = false
	export let promo_active: boolean
	export let price_can_increase = true
	export let product_ref: number | null = null
</script>

<div class="container">
	<div class=column>
		<div class=hide_on_wide>
			<HeaderPrice
				{base_price}
				{promo_discount_rate}
				{promo_active}
				{product_title}
				{price_can_increase}
			/>
		</div>

		<slot name=image />

		{#if show_color_picker}
			{#if compact_color_picker}
				<div class=hide_on_wide>
					<slot name=color_picker />
				</div>
			{:else}
				<slot name=color_picker />
			{/if}
		{/if}
	</div>

	<div class=column>
		<div class=hide_on_narrow>
			<HeaderPrice
				{base_price}
				{promo_discount_rate}
				{promo_active}
				{product_title}
				{price_can_increase}
			/>
		</div>

		<slot name=input />

		{#if show_color_picker && compact_color_picker}
			<div class=hide_on_narrow>
				<slot name=color_picker />
			</div>
		{/if}

		<CustomAddToCart
			{configured_price}
			{product_title}
			{cart_endpoint}
			{shopping_cart_object}
			{disable_add_to_cart}
			{product_ref}
		></CustomAddToCart>
	</div>
</div>

<style>
	.container {
		--contrast-text: #fff;
		--contrast-gray: #b3b3b3;
		--disabled-gray: #686868;
		--input-border-gray: #666; /* woocommerce dark.css has the same color */
		--trex-green: #CEFF51;
		--better-contrast-background: #333;
		--attention-red: #f00;

		font-family: "Protipo Wide", "Helvetica Neue", Helvetica, Arial, sans-serif;

		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 16px;
		padding: 0 10px;
		max-width: 100%;
	}

	.column {
		min-width: 300px;
		width: 100%;
		flex-basis: 41%;
		flex-grow: 1;

		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.hide_on_narrow {
		display: none;
	}

	@media (min-width: 850px) {
		.container {
			flex-direction: row;
			align-items: flex-start;
		}
		.hide_on_narrow {
			display: initial;
		}
		.hide_on_wide {
			display: none;
		}
	}
</style>
